import { useSelector } from "react-redux";
import identitySelectors from "../../../../../../../../selectors/identity";
import { useNotifyRolesForPerson } from "../../../../../../hooks/useNotifyRolesForPerson";
import { useCoreDepartments } from "../../../../../../../../hooks/useDepartments";

export function useNotifyUserDepartments({ limitToUsersRoles = false } = {}) {
  const userId = useSelector(identitySelectors.getUserId);
  const isCommunicationsUser = useSelector(identitySelectors.isCommunicationsUser);
  const isCommunicationsAdmin = useSelector(identitySelectors.isCommunicationsAdmin);
  const isNone = !isCommunicationsUser && !isCommunicationsAdmin;

  const { departmentsQuery } = useCoreDepartments();
  const departments = departmentsQuery.data ?? [];

  const { notifyRoles, isNotifyRolesLoading } = useNotifyRolesForPerson({
    personId: userId,
  });

  const isLoading = departmentsQuery.isLoading || isNotifyRolesLoading;

  const emptyReturnValue = {
    departments: [],
    isLoading,
  };

  if (isNone) return emptyReturnValue;
  if (!userId || !departments) return emptyReturnValue;

  if (isCommunicationsAdmin || !limitToUsersRoles) return { departments, isLoading };

  if (!notifyRoles) return emptyReturnValue;

  const filteredDepartments = departments
    .filter((department) => {
      return department.notifyShowInSendGroups && notifyRoles.some((role) => role.departmentId === department.id);
    })
    .sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

  return {
    departments: filteredDepartments,
    isLoading,
  };
}
